import { render, staticRenderFns } from "./MoreRuleTables.vue?vue&type=template&id=7024bb36&"
import script from "./MoreRuleTables.vue?vue&type=script&lang=js&"
export * from "./MoreRuleTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports